import initVue from "./vue/init";
import initMenu from "./main-menu";
import initPageHeaderResize from "./page-header-resize";
import animationsV2 from "./animationsv2";
import featurePanel from "./feature-panel";
import initCookieAccept from "./cookie-accept";
import initSliders from "./sliders";
import initHomeHeroVideo from "./home-hero-video";
import chartsPanel from "./charts-panel";
import filterReports from "./filter-reports";
import statsCounter from "./stats-counter";

function ready(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(() => {
  initVue();
  initMenu();
  initPageHeaderResize();
  initCookieAccept();
  animationsV2();
  featurePanel();
  initSliders();
  initHomeHeroVideo();
  chartsPanel();
  filterReports();
  statsCounter();

  // Tab
  const tabButtons = document.querySelectorAll(".tabs__pills .btn");
  const tabContents = document.querySelectorAll(".tabs__panels > div");
  const tabHeader = document.querySelector(".tab-header");
  const tabBackground = document.querySelectorAll(".tab-background");

  if (tabButtons && tabContents) {
    tabButtons.forEach((tabBtn) => {
      tabBtn.addEventListener("click", () => {
        const tabId = tabBtn.getAttribute("data-id");

        tabButtons.forEach((btn) => btn.classList.remove("active"));
        tabBtn.classList.add("active");

        tabContents.forEach((content) => {
          content.classList.remove("active");

          if (content.id === tabId) {
            content.classList.add("active");
          }
        });

        // Handle individual tab activation
        tabBackground.forEach((background) =>
          background.classList.remove("active"),
        );

        const activeBackground = document.querySelector(
          `.tab-background[data-id="${tabId}"]`,
        );

        if (activeBackground) {
          activeBackground.classList.add("active");
        }

        if (tabHeader) {
          tabHeader.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    });
  }

  // Show hidden contents (Fund)
  const fundPanel = document.querySelector(".fund-panel");
  const fundDetails = document.querySelector("#hidden-content");
  const showContent = document.querySelector("#show-content");

  if (fundDetails && showContent) {
    fundDetails.style.maxHeight = "0px";

    showContent.addEventListener("click", (e) => {
      e.preventDefault();
      const isOpen = fundDetails.classList.contains("is-open");

      if (isOpen) {
        fundPanel.style.paddingBottom = "0px";
        fundDetails.style.maxHeight = "0px";
        fundDetails.classList.remove("is-open");
        showContent.textContent = "View more";
      } else {
        fundPanel.style.paddingBottom = "50px";
        fundDetails.style.maxHeight = fundDetails.scrollHeight + "px";
        fundDetails.classList.add("is-open");
        showContent.textContent = "View less";
      }
    });

    window.addEventListener("resize", () => {
      if (fundDetails.classList.contains("is-open")) {
        fundDetails.style.maxHeight = fundDetails.scrollHeight + "px";
      }
    });
  }

  // Fix background (image + video) once hero is less than 50% visible
  document.addEventListener("DOMContentLoaded", () => {
    const hero = document.querySelector(".content__internal-hero-panel");
    const bgImage = document.querySelector(".bg-image");

    if (hero && bgImage) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // If hero is less than 50% visible apply fix position
            if (entry.intersectionRatio <= 0.5) {
              bgImage.classList.add("fixed");
            } else {
              bgImage.classList.remove("fixed");
            }
          });
        },
        {
          threshold: [0, 0.5, 1],
        },
      );

      observer.observe(hero);
    }
  });
});
